// Ödeme Alınamadı (POS hata) penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.posPaymentError';

export const posPaymentErrorGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Ödeme alınamadığında ne yapmalı?'),
  intro: t(`${G}.intro`, 'Bu pencere, kartlı (POS) ödeme yazarkasa veya POS cihazında başarısız olduğunda çıkar. Doğru seçim için önce şunu öğrenin: müşterinin kartından para çekildi mi? Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Ödeme Alınamadı'),
    body: t(`${G}.regions.body`, 'Hata ve cihaz durumu'),
    footer: t(`${G}.regions.footer`, 'Seçenekler'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Hatayı okuyun, slibi kontrol edin'),
      text: t(`${G}.s1.text`, 'Kırmızı kutuda cihazdan gelen hata yazar. Karar vermeden önce POS slibinin çıkıp çıkmadığına ve cihaz ekranına bakın. Bu pencere açıkken satış sisteme kaydedilmemiştir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Kağıt bitti uyarısında: kağıt kapağını açın, yeni ruloyu takın, kapağı kapatıp "Yeniden Dene"ye basın.'),
        t(`${G}.s1.tip2`, 'Beko X30TR zaman aşımında: önce cihazda Ödeme Al ekranındaysanız sol üstten "Fişi İptal Et" ile iptal edin, parçalı ödeme ekranına geçtiyse tutarı tamamlayın veya cihazı yeniden başlatın; sonra "Yeniden Dene". Aksi halde çift satış oluşabilir.'),
        t(`${G}.s1.tip3`, 'Beko\'da zaman aşımından sonra sistem 10 saniye boyunca cihazdan geç yanıt bekler; ödeme cihazda tamamlanmışsa pencere kendiliğinden kapanır ve satış kaydedilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s2.title`, '2. Ödemeyi kontrol et (Ingenico 5000F)'),
      text: t(`${G}.s2.text`, '"Ödemeyi Kontrol Et (Cihaz Durumunu Sorgula)" cihazdan gerçek ödeme durumunu okur. Ödeme alınmışsa fiş kapatılır ve "✅ Ödemeyi Kaydet (Cihazda Alındı Doğrulandı)" çıkar: buna basınca satış kaydedilir, yeni fiş kesilmez.'),
      tips: [
        t(`${G}.s2.tip1`, 'Kısmi ödeme varsa kalan tutarı cihazdan tamamlayın veya işlemi cihazdan iptal edip yeniden sorgulayın.'),
        t(`${G}.s2.tip2`, 'Fişte ödeme görünmüyorsa fişe dokunulmaz; cihaz banka ekranında bekliyor olabilir. Ödeme sürüyorsa bitince yeniden sorgulayın.'),
        t(`${G}.s2.tip3`, 'Açık işlem bulunamadıysa durum kesin değildir: slip çıktıysa "Yine de Devam Et", çıkmadıysa "Yeniden Dene".'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s3.title`, '3. Takılı belgeyi iptal edin'),
      text: t(`${G}.s3.text`, '"Belgeyi İptal Et" (Ingenico 5000F, kağıt hatası dışında) cihazda açık kalmış belgeyi iptal eder. Sorgu "ödeme görünmüyor" dediyse "Fişi İptal Et ve Yeniden Dene (Ödeme Alınmadıysa)" çıkar; iptal başarılı olunca "Yeniden Dene" ile güvenle tekrar deneyebilirsiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kartından para çekilmiş bir müşterinin belgesini iptal etmeyin; önce durumu sorgulayın.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Yeniden dene ya da yine de devam et'),
      text: t(`${G}.s4.text`, '"Yeniden Dene" aynı ödemeyi cihaza tekrar gönderir; yalnız paranın çekilmediğinden eminseniz veya müşteri başka kart verecekse kullanın. "Yine de Devam Et (Ödeme Alındıysa Satışı Kaydet)" (Ingenico 5000F) satışı yazarkasa olmadan kaydeder: stok düşer, tutar POS\'un banka hesabına işlenir, yeni fiş kesilmez.'),
      tips: [
        t(`${G}.s4.tip1`, 'Para çekildiği halde "Yeniden Dene" derseniz müşteriden iki kez ödeme alınabilir.'),
        t(`${G}.s4.tip2`, 'Para çekildiği halde satışı kaydetmeden kapatırsanız ödeme sistemde görünmez; gün sonunda banka/POS farkı çıkar.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Kapat veya sepeti temizle'),
      text: t(`${G}.s5.text`, '"Kapat (Sepet Korunur)" pencereyi kapatır; satış kaydedilmez, sepet olduğu gibi kalır, yeni ürün ekleyebilir veya başka ödeme türü seçebilirsiniz. "Sepeti Temizle ve Kapat" müşteri vazgeçtiyse sepeti sıfırlar; satış kaydedilmez. Restoran ekranında bu düğme yoktur.'),
    },
  ],
});
